angular.module('jv.MyAccount.JobAlerts.Ctrl', [
    'jv.common.root-modal.directive',
    'jv.Common.Modal',
    'jv.Common.AjaxSelect',
    'jv.simple-select.directive',
    'jv.Common.i18n'
])
.controller('jobAlertsController', [
    '$scope', '$rootScope', 'myAccount', '$q', '$timeout', 'i18n',
    function($scope, $rootScope, myAccount, $q, $timeout, i18n) {
        var state = $scope.state = {
            companies: [],
            locations: {},
            editCopy: {}
        };
        $rootScope.breadcrumbsConfig.links.unshift({
            linkText: i18n['JOB_ALERTS'],
            link: $scope.jvUrls.admin+'/myaccount/profile.html#/jobAlerts'
        });
        
        function getJobAlertCompanies() {
            $scope.flags.loading = true;
            myAccount.getJobAlertCompanies().then(function(data) {
                if(data) {
                    $scope.allowJobAlertCreation = data.allowJobAlertCreation;
                    state.companies = data.companies;
                }
            }).finally(function() {
                $scope.flags.loading = false;
            });
        }

        getJobAlertCompanies();
        
        function confirmDelete() {
            var deferred = $q.defer();
            confirmDelete.deferred = deferred;
            return deferred.promise;
        }
        
        function getCompanyAlerts(companyEId) {
            return myAccount.getJobAlerts(companyEId);
        }
        
        function getHireCompany(companyEId) {
            return myAccount.getCompany(companyEId);
        }

        function saveAlert(alert) {
            return myAccount.saveJobAlert(alert);
        }
        
        function createAlert(alert) {
            return myAccount.createJobAlert(alert);
        }

        function deleteAlert(alert) {
            return myAccount.deleteJobAlert(alert.EId);
        }

        function deleteAllAlerts(companyEId) {
            return myAccount.deleteAllJobAlerts(companyEId);
        }

        function renewAllAlerts(companyEId) {
            return myAccount.renewAllJobAlerts(companyEId);
        }

        function getCompany(companyEId) {
            return state.companies.filter(function(company) {
                return (company.companyEId === companyEId);
            }).pop();
        }

        function getCompanyLocation(companyEId, locationKey) {
            var company = getCompany(companyEId);
            if (!company) {
                return;
            }
            return company.jobAlertSubscriptionLocations.filter(function(location){
                return (location.locationKey === locationKey);
            }).pop();
        }

        function getCompanyCategory(companyEId, categoryEId) {
            var company = getCompany(companyEId);
            if (!company) {
                return;
            }
            return company.categories.filter(function(category){
                return (category.EId === categoryEId);
            }).pop();
        }

        $scope.toggleCompany = function(company) {
            if (!company.alerts) {
                $scope.flags.loading = true;
                getCompanyAlerts(company.companyEId).then(function(data) {
                    company.alerts = data.alerts;
                    company.categories = data.categories;
                    company.jobAlertSubscriptionLocations = data.activeJobAlertSubscriptionLocations;
                }).catch(function() {
                    $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
                }).finally(function() {
                    $scope.flags.loading = false;
                });
            }
            company.expanded = !company.expanded;
        };
        
        $scope.editAlert = function(alert) {
            state.editCopy[alert.EId] = {
                EId: alert.EId,
                category: alert.categoryEId,
                location: alert.subscriptionType === 'ActualLocation' ? alert.subscribedLocation : alert.locationEId
            };
            alert.editing = true;
        };

        $scope.cancelEditAlert = function(alert) {
            state.editCopy[alert.EId] = null;
            alert.editing = false;
        };

        $scope.saveEditAlert = function(alert) {
            var copy = state.editCopy[alert.EId];
            var company = getCompany(alert.companyEId);
            var category = getCompanyCategory(alert.companyEId, copy.category);
            var location = getCompanyLocation(alert.companyEId, copy.location);
            angular.extend(alert, {
                locationName: (location) ? location.locationName : 0,
                locationEId : (location) ? location.locationKey:'',
                subscribedLocation:(location) ? location.locationKey:'',
                location: (location) ? location : JSON.stringify(null),
                categoryName: category.name,
                categoryEId: category.EId
            });
            $scope.flags.loading = true;
            saveAlert(alert).then(function() {
                $scope.cancelEditAlert(alert);
                $scope.showMsg('DATA_SAVED');
                company.renewed = true;
            }).catch(function() {
                $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
            }).finally(function() {
                $scope.flags.loading = false;
            });
        };
        
        $scope.saveNewJobAlert = function() {
            if($scope.user && $scope.user.companyEId) {
                var alert = {
                    companyEId : $scope.user.companyEId,
                    categoryEId : state.category,
                    location : state.location || JSON.stringify(null)
                };
                $scope.flags.loading = true;
                createAlert(alert).then(function() {
                    $scope.cancelJobAlert();
                    $scope.showMsg('DATA_SAVED');
                }).catch(function() {
                    $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
                }).finally(function() {
                    $scope.flags.loading = false;
                    getJobAlertCompanies();
                });
            }
        };

        $scope.deleteAlert = function(alert) {
            state.showConfirmDelete = true;
            confirmDelete().then(function() {
                $scope.flags.loading = true;
                return deleteAlert(alert);
            }).then(function() {
                var company = getCompany(alert.companyEId);
                alert.deleted = true;
                company.deleted = company.alerts.every(function(companyAlert) {
                    return companyAlert.deleted;
                });
                $scope.showMsg('DELETED');
            }).catch(function(msg) {
                if (msg !== 'cancelled') {
                    $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
                }
            }).finally(function() {
                state.showConfirmDelete = false;
                $scope.flags.loading = false;
            });
        };

        $scope.confirmDelete = function() {
            if (confirmDelete.deferred) {
                confirmDelete.deferred.resolve();
            }
        };

        $scope.cancelDelete = function() {
            if (confirmDelete.deferred) {
                confirmDelete.deferred.reject('cancelled');
            }
        };

        $scope.deleteAll = function(companyEId) {
            state.showConfirmDeleteAll = true;
            confirmDelete().then(function() {
                $scope.flags.loading = true;
                return deleteAllAlerts(companyEId);
            }).then(function() {
                var company = state.companies.filter(function(item) {
                    return (item.companyEId === companyEId);
                }).pop();
                if (company) {
                    company.deleted = true;
                }
                $scope.showMsg('DELETED');
            }).catch(function(msg) {
                if (msg !== 'cancelled') {
                    $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
                }
            }).finally(function() {
                $scope.flags.loading = false;
                state.showConfirmDeleteAll = false;
            });
        };
        
        $scope.createJobAlert = function(companyEId) {
            $scope.createJobAlertError = false;
            state.category = '';
            state.location = '';
            getHireCompany(companyEId).then(function(data) {
                if(data && data.categories && data.jobAlertSubscriptionLocations) {
                    $scope.categories = data.categories;
                    $scope.jobAlertSubscriptionLocations = data.jobAlertSubscriptionLocations;
                    state.showCreateJobAlert = true;
                } else {
                    $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
                }
            }).catch(function() {
                $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
            }).finally(function() {
                $scope.flags.loading = false;
            });
        };
        
        $scope.cancelJobAlert = function() {
            state.showCreateJobAlert = false;
        };

        $scope.renewAll = function(companyEId) {
            $scope.flags.loading = true;
            renewAllAlerts(companyEId).then(function() {
                var company = state.companies.filter(function(item) {
                    return (item.companyEId === companyEId);
                }).pop();
                if (company) {
                    company.renewed = true;
                }
                $scope.showMsg('SUBSCRIPTION_RENEWED');
            }).catch(function() {
                $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
            }).finally(function() {
                $scope.flags.loading = false;
            });
        };

        $scope.notDeleted = function(item) {
            return !item.deleted;
        };

        $scope.hasAlerts = function() {
            if (state.companies) {
                return state.companies.filter($scope.notDeleted).length;
            }
            return false;
        };
    }
]);